<template>
    <div class="search-insurace-types">
        <v-autocomplete
            v-model="insuranceType"
            :items="items"
            :search-input.sync="search"
            class="rounded-0"
            label="Type d'organisme"
            outlined
            dense
            hide-selected
            hide-details
            append-icon="mdi-chevron-down"
            item-text="label"
            item-value="code"
            no-data-text="Aucune convention collective ne correspond à votre recherche"
            :clearable="true"
        />
    </div>
</template>

<script>
import { get } from "lodash";

export default {
    props: ["value", "annotationOptions"],
    data() {
        return {
            insuranceType: null,
            search: null,
        };
    },
    mounted() {
        this.insuranceType = this.value;
    },
    watch: {
        async insuranceType(value) {
            this.$emit("input", value);
        },
        value(_value) {
            this.insuranceType = _value;
        },
    },
    computed: {
        items() {
            return Object.keys(this.annotationOptions)
                .map(key => {
                    return this.annotationOptions[key]["type"] === "insuranceType"
                        ? {
                              code: key,
                              label: get(this.annotationOptions, `${key}.label`, ""),
                          }
                        : null;
                })
                .filter(v => v !== null);
        },
    },
};
</script>

<style lang="sass" scoped>
.search-insurace-types
    margin: 8px
</style>
